import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import TopUp from './TopUp';


export default function NavView(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function logoTap() {
        window.location.href = window.location.origin;
    }

    function musicTap() {
        dispatch(settingActions.setPlayingMusic());
    }

    return (
        <Stack
            id={'nav_view'}
            sx={{
                position: 'fixed',
                height: '90rem',
                zIndex: 100,
                width: 1,
                minWidth: '1200px',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '1155px',
                background: 'linear-gradient(#000000ff , #00000000)',
            }}>

            <Box sx={{
                width: 1,
                minWidth: '1200px',
                height: '110rem',
                background: 'linear-gradient(#000000ff , #00000000)',
                position: 'fixed',
                top: 0,
                zIndex: 0,
            }} />

            <Box
                onClick={logoTap}
                component={'img'}
                src={JSTool.getImgPath('logo_new.png')}
                sx={{
                    height: 0.6,
                    mr: 4,
                    cursor: 'pointer',
                    zIndex: 2,
                }} />

            {props.isDownload &&
                <Stack sx={{
                    flexDirection: 'row',
                }}>
                    <NavItem index={0} title="Home" />
                    <NavItem index={1} title="Characters" />
                    <NavItem index={2} title="Summons" />
                    <NavItem index={3} title="Game Features" />
                </Stack>}

            {!props.isDownload &&
                <Stack sx={{
                    flexDirection: 'row',
                }}>
                    <NavItem index={0} title="Home" />
                    <NavItem index={1} title="Characters" />
                    <NavItem index={2} title="Summons" />
                    <NavItem index={3} title="Game Features" />
                </Stack>}

            <TopUp />

            {/* 垂直居中 */}
            <Box
                onClick={musicTap}
                component={'img'}
                src={settingData.playingMusic ? JSTool.getImgPath('bg/ico-music.png') : JSTool.getImgPath('bg/ico-music-close.png')}
                sx={{
                    height: '25rem',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    right: 30,
                    animation: settingData.playingMusic ? 'musicRotate 3s linear infinite' : '',
                    cursor: 'pointer',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.1)',
                    }
                }} />
        </Stack>
    );
}

function NavItem(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    function itemClick() {
        const index = props.index;
        dispatch(settingActions.setNavIndex(index));
        // JSTool.scrollToView(`scroll_to${index}`); //滚动

        var instance = $('#home_page_sp')[0].swiper;  //SP
        instance.slideTo(index);
    }

    return (
        <Stack
            onClick={itemClick}
            sx={{
                mx: '15rem',
                zIndex: 2,
            }}>

            <Typography sx={{
                cursor: 'pointer',
                textAlign: 'center',
                color: 'white',
                fontSize: '18rem',
                transitionDuration: '0.3s',
                fontFamily: window.font0,
                pb: '5rem',
                borderBottom: settingData.navIndex == props.index ? '2px solid white' : '2px solid transparent',
                '&:hover': {
                    transform: 'scale(1.1)',
                }
            }}>
                {props.title}
            </Typography>

        </Stack>
    );
}
